import { styled } from 'styled-components';

import { colors, cssBreakpoints, gutterWidth } from '#/theme/theme';

export const LayoutHeaderSearchSubmenuHolder = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LayoutHeaderDesktopSearchHolder = styled.div`
  padding: 16px ${gutterWidth / 2}px;
  background-color: ${colors.white};
  border-top: 1px solid ${colors.selectionGrey};

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    display: none;
  }
`;
